import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, Content, AlertController, ActionSheetController, Platform, ViewController, ToastController } from 'ionic-angular';
import { PhotoLibrary } from '../../../../providers/my-photo-library';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { PhotoAction, _PhotoAction } from '../../../../actions/photo.action';
import { CallNumber } from '@ionic-native/call-number';
import { AbstractPage } from '../../../_com/abstract-page';
import { ChatAction } from '../../../../actions/chat.action';
import { ReserveAction } from '../../../../actions/reserve.action';
import _ from 'underscore';
import { Subscription } from 'rxjs';
import moment from "moment";

/**
 * Generated class for the InterviewSheetEditStaffPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: "page-reserve-interview-edit-staff",
  templateUrl: "reserve-interview-edit-staff.html",
})
export class InterviewSheetEditStaffPage extends AbstractPage {
  // 予約情報
  // - サンプル
  // {"datetime":{"input":{"date":"2022-02-14T01:12:07.000Z","time":["2022-02-08T01:00:00.000Z","2022-02-08T05:00:00.000Z"]},"elapsed":{"h":4,"m":"00"},"date":"2022-02-14","time":["10:00","14:00"]},"family":{"id":"61127004a63367be6a543a9e","data":{"Family":{"name":"テストお名前","kana":"テストデータ","tel":"012-3456-789","type":"other","mail_address":"ryo.fujiwara@brightvie.me","zip":1234567,"address":"愛知県名古屋市","sns_keisai_status":"true","photo_uketori_status":"true","modified_user":"5ad6ab64a63367582f40221c","modified":"2022-Feb-13 07:56:43","created":"2021-Aug-10 21:24:36","children":["61127020a63367c06a543a94","614fdedaa63367da2e54941a"],"reset_token":null,"name2":"あああ","tel2":"012-3456-789","tel2_relation":"夫","id":"61127004a63367be6a543a9e"}}},"pickup":{"elapsed_time":"1","pickup_Name":"テストお名前","pickup_Name_kana":"テストデータ","tel":"0123456789","relation":"","type":"1","pickup_time":"2022-02-08T05:00:00.000Z"},"children":[{"id":"61127020a63367c06a543a94","childOfAge":[5,10],"data":{"Child":{"familyId":"61127004a63367be6a543a9e","newChild":false,"name":"太郎","kana":"たろう","gender":"boy","birthday":"2016-03-23T15:00:00.000Z","takuji_keiken_status":"true","allergy_status":"true","sikkan":"true","junyu_status":"false","modified_user":"5ad6ab64a63367582f40221c","modified":"2022-Feb-13 09:36:16","created":"2021-Aug-10 21:25:03","tabetakotoaru_foods":["3","4","5"],"keijyo_yasai":"3","rinyushoku_shokuzai":["jagaimo","ninjin","aona","tamanegi","kyabetsu"],"rinyushoku_tabetakotoaru_shokuzai":["jagaimo","ninjin","aona","kyabetsu","shoyu"],"rinyusyoku_okayu":"5","syokuji_ryo":"2","syokuji_kininaru_tabemura":true,"syokuji_kininaru_asobitabe":true,"seikatsu_rizumu_kisho":"2021-09-26T03:00:00.000Z","sanpo_sanka_status":"true","allergy_text":"2/10 あいうえお","sikkan_sonota_text":"2/10 かきくけこ","konamiruku_text":"2/10 さしすせそ","id":"61127020a63367c06a543a94"}}}],"memoToStaff":"","consent":true,"status":0,"reserve_request_date":"2022/02/08 10:13:00","type":"other","modified":"2022-Feb-08 17:19:48","created":"2022-Feb-08 10:13:00","id":"6201c39ce2accf064ee6d4ca"}
  reserve: any = {};
  // 家族情報
  // - サンプル
  // {"id":"61127004a63367be6a543a9e","data":{"Family":{"name":"テストお名前","kana":"テストデータ","tel":"012-3456-789","type":"other","mail_address":"tech@mail","zip":1234567,"address":"愛知県名古屋市","sns_keisai_status":"true","photo_uketori_status":"true","modified_user":"5ad6ab64a63367582f40221c","modified":"2022-Feb-13 07:56:43","created":"2021-Aug-10 21:24:36","children":["61127020a63367c06a543a94","614fdedaa63367da2e54941a"],"reset_token":null,"name2":"あああ","tel2":"012-3456-789","tel2_relation":"夫","id":"61127004a63367be6a543a9e"}}}
  family: any = {};
  // 子供情報
  // - サンプル
  // {"Child":{"familyId":"61127004a63367be6a543a9e","newChild":false,"name":"太郎","kana":"たろう","gender":"boy","birthday":"2016-03-23T15:00:00.000Z","takuji_keiken_status":"true","allergy_status":"true","sikkan":"true","junyu_status":"false","modified_user":"5ad6ab64a63367582f40221c","modified":"2022-Feb-13 09:36:16","created":"2021-Aug-10 21:25:03","tabetakotoaru_foods":["3","4","5"],"keijyo_yasai":"3","rinyushoku_shokuzai":["jagaimo","ninjin","aona","tamanegi","kyabetsu"],"rinyushoku_tabetakotoaru_shokuzai":["jagaimo","ninjin","aona","kyabetsu","shoyu"],"rinyusyoku_okayu":"5","syokuji_ryo":"2","syokuji_kininaru_tabemura":true,"syokuji_kininaru_asobitabe":true,"seikatsu_rizumu_kisho":"2021-09-26T03:00:00.000Z","sanpo_sanka_status":"true","allergy_text":"2/10 あいうえお","sikkan_sonota_text":"2/10 かきくけこ","konamiruku_text":"2/10 さしすせそ","id":"61127020a63367c06a543a94"}}
  child: any = {};

  interviewId = ""; // 問診票IDを格納

  interviewInfo: {
    temperature_child?: string;
    temperature_parent?: string;
    temperature_parent_kazecheck?: string;
    drug_confirm_1?: string;
    drug_confirm_2?: string;
    drug_confirm_staff_name?: string;

    // - 新型コロナウィルス感染防止に関するお願い への同意
    agreemented: boolean;
    // - 離乳食の進み具合: ご飯(F:普通のご飯/N:軟飯/5/7/10)
    rinyusyoku_okayu?: string;
    // - 離乳食の進み具合: 野菜などの形状 (1:幼児食...~ 5:初期（すりおろし）)
    keijyo_yasai?: string;
    // - アレルギー
    allergy_text?: string;
    // -今回新たに食べられるようになった食材（任意）
    tabetakotoaru_foods?: string[];
    // - 保育中の不可事項
    other_questions?: string;
    // - 授乳
    breastfeed?: "true" | "false"; // NOTE: あえて文字列で定義しているっぽい(最初の作りから
    breastfeed_description?: string;
    breastfeed_lasttime?: string; // 最後の授乳時間
    breastfeed_nexttime?: string; // 預かり中予定時間
    breastfeed_drinkcc?: string; // 飲む量
    // - 怪我
    injured?: "true" | "false"; // NOTE: あえて文字列で定義しているっぽい(最初の作りから
    injurd_description?: string;
    // - お昼寝
    napped?: "true" | "false"; // NOTE: あえて文字列で定義しているっぽい(最初の作りから
    nap_description?: string;
    // - 与薬
    use_drug?: "true" | "false"; // NOTE: あえて文字列で定義しているっぽい(最初の作りから)
    use_drug_description?: string;
    // ** 与薬書 **
    // - 薬剤処方日
    drug_prescription_date?: string;
    // - 医療機関名
    drug_hospital_name?: string;
    // - 薬情報
    drug_list: {
      name: string;
      what: string;
      what_other_description: string;
      when: string;
      when_other_description: string;
      how: string;
      how_other_description: string;
      external_description: string;
      description: string;
    }[];
    // - 与薬依頼日
    drug_use_requested_date?: string;
    // - 与薬依頼者(保護者名)
    drug_use_requester_name?: string;
    // ** ** **

    // - 予約時からの変更点
    change_description?: string;
    // - 特記事項
    notice?: string;

    // - 食札（スタッフ専用)
    shokusatsu?: "true" | "false"; // NOTE: あえて文字列で定義しているっぽいので他と合わせる
    shokusatsu_pictures?: string[];
    // - スタッフ専用 ファイル添付
    staff_only_files?: string[]

  } = {
    agreemented: false,
    drug_list: [],
  };
  isDataExists = true; // 問診票データが存在するかどうか

  // api側に送るデータを定義
  data = {
    id: "",
    child: {},
    reserve: {},
    interviewInfo: {},
    // reserve_request_date: "",
    // created: "",
  };

  // カレンダー表示のパラメータ(親クラスのデータを上書き)
  mbscDateOptions: any = {
    display: "center",
    setOnDayTap: true,
    lang: "ja",
    animate: "fade",
    dateFormat: "yy/m/d(D)",
    firstSelectDay: 1,
    buttons: [],
    max: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    ),
  };

  photoAction: _PhotoAction;
  captureData$: Subscription;
  captureDatas$: Subscription;

  breastfeed_lasttime = new Date();

  breastfeed_nexttime = new Date();

  @ViewChild(Content) content: Content;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public chatAction: ChatAction,
    public reserveAction: ReserveAction,
    private pv: PhotoViewer,
    private pl: PhotoLibrary,
    private alertController: AlertController,
    private toastController: ToastController,
    private actionSheetController: ActionSheetController,
    public tmpPhotoAction: PhotoAction,
    private plt: Platform,
    private callNumber: CallNumber,
    public viewController: ViewController,
    private el: ElementRef
  ) {
    super();

    this.photoAction = tmpPhotoAction.getInstance();
    this.takePictureDataSubscribe();

    this.reserve = this.navParams.data.reserve; // 予約情報

    if (this.navParams.data.isDetail) {
      // 予約詳細からきた場合
      this.child = this.navParams.data.child; // 子ども情報
      this.interviewInfo = this.navParams.data.interviewInfo; // 問診票情報
      this.interviewId = this.navParams.data.interviewId; // 問診票ID

      if (this.interviewInfo.breastfeed_lasttime) {
        this.breastfeed_lasttime = new Date(`${moment().format("YYYY/MM/DD")} ${this.interviewInfo.breastfeed_lasttime}`);
      }
      if (this.interviewInfo.breastfeed_nexttime) {
        this.breastfeed_nexttime = new Date(`${moment().format("YYYY/MM/DD")} ${this.interviewInfo.breastfeed_nexttime}`);
      }

    } else {
      // 問診票詳細からきた場合
      this.child = this.navParams.data.child.Child; // 子ども情報
    }

    this.pl; //for TSLint
    this.pv; //for TSLint
    this.plt; //for TSLint
    this.callNumber; //for TSLint

    super.readyDomAccess(this.el);
  }

  /**
   * 画面が呼び出される前にロード
   */
  ionViewDidLoad() {
    // 受け取った値をセットする
  }

  /**
   * subscription破棄
   */
  ngOnDestroy() {
    this.captureData$.unsubscribe();
    this.captureDatas$.unsubscribe();
    this.photoAction = null;
  }


  /**
   * キャンセル処理
   */
  cancel() {
    //入力項目タッチ無し
    if (!this.hasTouched()) {
      this.viewController.dismiss();
      return;
    }

    //入力項目タッチありで、画面を閉じる
    this.confirm(
      this.alertController,
      "画面を閉じます。よろしいですか？",
      () => {
        this.viewController.dismiss();
      }
    );
  }

  showAlertMessage(text: string) {
    this.alert(this.alertController, text);
  }

  /**
   * 問診票情報保存
   */
  save() {

    if (!this.interviewInfo.temperature_child) {
      this.showAlertMessage("体温計測欄の「お子さま体温」に関する内容を入力してください");
      return;
    }

    if (!this.interviewInfo.temperature_parent) {
      this.showAlertMessage("体温計測欄の「保護者さま体温」に関する内容を入力してください");
      return;
    } else if (this.interviewInfo.temperature_parent === '37.5') {
      if (!this.interviewInfo.temperature_parent_kazecheck) {
        this.showAlertMessage("体温計測欄の「風邪症状なし」に関する内容を入力してください");
        return;
      }
    }

    if (!this.interviewInfo.shokusatsu) {
      this.showAlertMessage("食札に関する内容を入力してください");
      return;
    }


    if (this.interviewInfo.use_drug === 'true') {
      if (!this.interviewInfo.drug_confirm_1) {
        this.showAlertMessage("与薬欄の「スタッフの確認項目」に関する内容を入力してください");
        return;
      }
      if (!this.interviewInfo.drug_confirm_2) {
        this.showAlertMessage("与薬欄の「スタッフの確認項目」に関する内容を入力してください");
        return;
      }
      if (!this.interviewInfo.drug_confirm_staff_name) {
        this.showAlertMessage("与薬欄の「スタッフの確認項目」に関する内容を入力してください");
        return;
      }

    }



    // 必須チェック
    if (this.hasInvalidRequired()) {
      this.showAlertMessage(
        "未入力の項目を確認してください。（" +
        this._el.querySelectorAll(".requiredError").length +
        "箇所）"
      );
      return;
    }

    // 問診票情報が存在する場合、問診票IDを格納する
    if (this.interviewId) {
      this.data["id"] = this.interviewId;
    } else {
      this.data["id"] = "";
    }

    this.data["interviewInfo"] = this.interviewInfo; // 問診票情報を格納
    this.data["reserve"] = this.reserve; // 予約情報
    this.data["child"] = this.child;

    // 登録
    this.confirm(
      this.alertController,
      "入力された内容で問診票を送信します。よろしいですか？",
      () => {
        this.reserveAction.saveInterviewSheet(this.data).subscribe((data) => {
          this.toast(this.toastController, "問診票情報を送信しました。");
          this.navCtrl.pop();
        });
      }
    );
  }

  addDrugBox() {
    if (!this.interviewInfo.drug_list) {
      this.interviewInfo.drug_list = [];
    }
    this.interviewInfo.drug_list.push({
      name: "",
      what: "",
      what_other_description: "",
      when: "",
      when_other_description: "",
      how: "",
      how_other_description: "",
      external_description: "",
      description: "",
    });
  }
  deleteDrugBox(i) {
    this.interviewInfo.drug_list = this.interviewInfo.drug_list.filter(
      (data, index) => {
        return i !== index;
      }
    );
  }

  // **********************
  // ** 写真データを扱う
  // **********************
  /**
   * 写真データ取得時イベント
   */
  private takePictureDataSubscribe() {
    var self = this;

    /* カメラ撮影(1数) */
    this.captureDatas$ = this.photoAction.captureDatas$.subscribe(
      (imageDatas) => {
        if (self.photoAction.getScreen() === "shokusatsu") {
          this.selectedSholusatsuPicture(imageDatas);
        } else if (self.photoAction.getScreen() === "staffOnlyFiles") {
          this.selectedStaffOnlyFiles(imageDatas);
        }
      }
    );

    /* 写真選択(複数枚) */
    this.captureData$ = this.photoAction.captureData$.subscribe((imageData) => {
      if (self.photoAction.getScreen() === "shokusatsu") {
        this.selectedSholusatsuPicture([imageData]);
      } else if (self.photoAction.getScreen() === "staffOnlyFiles") {
        this.selectedStaffOnlyFiles([imageData]);
      }

    });
  }



  /****************
   * 食札関連
   */

  // 食札の画像を選択する
  shokusatsuTakePicture() {
    let actionSheet = this.actionSheetController.create({
      title: "選択してください",
      buttons: [
        {
          text: "写真を撮影する",
          handler: () => {
            this.photoAction.takeCamera({needModal: true,　screen: "shokusatsu"　});
          },
        },
        {
          text: "アルバムから選択する",
          handler: () => {
            this.photoAction.photoSelectMultiple({ needModal: true, screen: "shokusatsu" });
          },
        },
        {
          text: "キャンセル",
          role: "cancel",
        },
      ],
    });
    actionSheet.present();
  }

  // 食札の画像が選択された
  selectedSholusatsuPicture(imageDatas:any) {
    console.log(imageDatas);
    // TODO: 画像のURLをセットしておく？
    // -> ここで表示されているのがBase64の画像で良いか？

    // 問診票に画像を保存する
    if (!this.interviewInfo.shokusatsu_pictures) {
      this.interviewInfo.shokusatsu_pictures = [];
    }
    if (Array.isArray(imageDatas)) {
      for (const image of imageDatas) {
        this.interviewInfo.shokusatsu_pictures.push(image);
      }
    } else {
      this.interviewInfo.shokusatsu_pictures.push(imageDatas);
    }
  }

  // 食札の画像を削除
  removeSholusatsuPicture(index) {
    this.confirm(this.alertController, "削除します。よろしいですか？", () => {
      // TODO: 実ファイルは削除されないけどいいか・・・！？
      this.interviewInfo.shokusatsu_pictures = this.interviewInfo.shokusatsu_pictures.filter((image, i) => {
        return `${index}` !== `${i}`;
      });
    });
  }


  /****************
   * スタッフ専用 ファイル添付
   */

  staffOnlyFilesTakePicture() {
    let actionSheet = this.actionSheetController.create({
      title: "選択してください",
      buttons: [
        {
          text: "写真を撮影する",
          handler: () => {
            this.photoAction.takeCamera({ needModal: true, screen: "staffOnlyFiles" });
          },
        },
        {
          text: "アルバムから選択する",
          handler: () => {
            this.photoAction.photoSelectMultiple({ needModal: true, screen: "staffOnlyFiles" });
          },
        },
        {
          text: "キャンセル",
          role: "cancel",
        },
      ],
    });
    actionSheet.present();
  }
  selectedStaffOnlyFiles(imageDatas: any) {
    console.log(imageDatas);
    // TODO: 画像のURLをセットしておく？
    // -> ここで表示されているのがBase64の画像で良いか？

    // 問診票に画像を保存する
    if (!this.interviewInfo.staff_only_files) {
      this.interviewInfo.staff_only_files = [];
    }
    if (Array.isArray(imageDatas)) {
      for (const image of imageDatas) {
        this.interviewInfo.staff_only_files.push(image);
      }
    } else {
      this.interviewInfo.staff_only_files.push(imageDatas);
    }

  }

  removeStaffOnlyFile(index) {
    this.confirm(this.alertController, "削除します。よろしいですか？", () => {
      // TODO: 実ファイルは削除されないけどいいか・・・！？
      this.interviewInfo.staff_only_files = this.interviewInfo.staff_only_files.filter((image, i) => {
        return `${index}` !== `${i}`;
      });
    });
  }



}



// WEBPACK FOOTER //
// ./src/pages/reserve/interview/edit-staff/reserve-interview-edit-staff.ts